<template>
    <div
        :class="{
            'plant-points': true,
            'default-background': background === 'green',
            'alt-background': background === 'white',
        }"
    >
        <img
            class="image"
            :src="image.src"
            :alt="image.alt"
            :width="image.width"
            :height="image.height"
        />
        <div>
            <h3 class="title">plant points</h3>
            <div class="description" v-html="description"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'plant-points-info',
        props: {
            points: {
                type: Number,
                default: 0,
            },
            description: {
                type: String,
                default: '',
            },
            image: {
                type: Object,
                default: () => ({}),
            },
            background: {
                type: String,
                default: 'green',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .plant-points {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;

        @include media-breakpoint-up(md) {
            flex-direction: row;
        }
    }
    .default-background {
        background-color: secondary-palette(10);
        border-radius: rem(48px);
        padding: rem(24px) rem(32px);
    }

    .alt-background {
        background-color: $white;
        border-radius: rem(48px);
        padding: 0;
    }

    .image {
        display: block;
        width: auto;
        height: 100px;
        margin: 0 auto;
    }

    .title {
        font-size: rem(28px);
    }

    .description::v-deep {
        *:last-child {
            margin-bottom: 0;
        }
        a {
            color: primary-palette(2);
            text-decoration: underline;
        }
    }
</style>
